import type { TenantBillingStatDTO } from '../tenantBillingStat.types';
import dayjs from 'dayjs';

export class TenantBillingStatModel {
  private readonly _dto: TenantBillingStatDTO;

  constructor(dto: TenantBillingStatDTO) {
    this._dto = dto;
  }

  get originDTO(): TenantBillingStatDTO {
    return this._dto;
  }

  get tenantId() {
    return this._dto.tenantId;
  }

  get month() {
    return this._dto.month;
  }

  get annualBillingAmountEstimate() {
    return this._dto.annualBillingAmountEstimate;
  }

  get annualPayment() {
    return this._dto.annualPayment;
  }

  get annualPaymentEstimate() {
    return this._dto.annualPaymentEstimate;
  }

  get monthlyBillingAmount() {
    return this._dto.monthlyBillingAmount;
  }

  get monthlyPayment() {
    return this._dto.monthlyPayment;
  }

  get monthlyPaymentEstimate() {
    return this._dto.monthlyPaymentEstimate;
  }

  get monthlyPaymentEstimateGrowthRate() {
    return this._dto.monthlyPaymentEstimateGrowthRate * 100;
  }

  get previousMonthlyBillingAmount() {
    return this._dto.previousMonthlyBillingAmount;
  }

  get previousMonthlyPayment() {
    return this._dto.previousMonthlyPayment;
  }

  get monthlyBillingAmountEstimateGrowthRate() {
    return this._dto.monthlyBillingAmountEstimateGrowthRate;
  }

  get optimizedAnnualPaymentEstimate() {
    return this._dto.optimizedAnnualPaymentEstimate;
  }

  get remainingOptimizedAnnualPaymentEstimate() {
    return this._dto.remainingOptimizedAnnualPaymentEstimate;
  }

  get remainingAnnualPaymentEstimate() {
    return this._dto.remainingAnnualPaymentEstimate ?? 0;
  }

  get remainingMonthlyPaymentEstimate() {
    const remainingMonth = 12 - dayjs().get('month');
    return Math.floor(this.remainingAnnualPaymentEstimate / remainingMonth);
  }

  get remainingAnnualPaymentReductionEstimate() {
    return this._dto.remainingAnnualPaymentReductionEstimate ?? 0;
  }

  get remainingMonthlyPaymentReductionEstimate() {
    const remainingMonth = 12 - dayjs().get('month');
    return Math.floor(this.remainingAnnualPaymentReductionEstimate / remainingMonth);
  }

  get optimizableAnnualPaymentEstimate() {
    return this._dto.annualPaymentEstimate - this._dto.remainingOptimizedAnnualPaymentEstimate;
  }

  get optimizableAnnualPaymentEstimateGrowthRate() {
    return -(this.optimizableAnnualPaymentEstimate * 100) / this._dto.annualPaymentEstimate;
  }

  get optimizableMonthlyPaymentEstimate() {
    return Math.floor(this.optimizableAnnualPaymentEstimate / 12);
  }

  get optimizableMonthlyPaymentEstimateGrowthRate() {
    return this.optimizableAnnualPaymentEstimateGrowthRate;
  }
}
